<!--
  The demo store's promo verdict page: the shared PromoVerdictPage with a fixture
  behind it. Everything visible lives in components/promotions/PromoVerdictPage.vue,
  which the live portal mounts too.
-->
<template>
  <PromoVerdictPage demo :promo="promo" />
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import PromoVerdictPage from '@/components/promotions/PromoVerdictPage.vue'
import { demoPromoById } from '@/demo/promosDemo'

const route = useRoute()
const promo = computed(() => demoPromoById(route.params.promoId))
</script>
